import { render, staticRenderFns } from "./BusinesUnitDate.vue?vue&type=template&id=23179e5e"
import script from "./BusinesUnitDate.vue?vue&type=script&lang=ts"
export * from "./BusinesUnitDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports